import angular from 'angular';

export default angular.module('components.backbutton', [])
    .component('backButton', {
        template: require('./backButton.pug')(),
        controller: ['$window', '$state',  function($window, $state) {
            var ctrl = this;

            ctrl.goBack = function() {
                $window.history.back();
            };

        }]
    })
    .name; 
